import { getValidationSchema } from '../../../common.validators';
import { FORM_FIELDS } from '../../../../../constants';

export const schema = () =>
    getValidationSchema([
        FORM_FIELDS.AGREEMENT,
        FORM_FIELDS.PURPOSE,
        FORM_FIELDS.AMOUNT,
        FORM_FIELDS.REGION,
        FORM_FIELDS.PHONE,
        FORM_FIELDS.SMS_CODE,
        // auto credit fields
        FORM_FIELDS.INITIAL_FEE,
        FORM_FIELDS.AUTO_BRAND,
        FORM_FIELDS.AUTO_MODEL,
        FORM_FIELDS.AUTO_YEAR,
        FORM_FIELDS.AUTO_BRAND_ID,
        FORM_FIELDS.AUTO_MODEL_ID,
    ]);
